<template>
  <v-menu v-model="menu" :close-on-content-click="false" :close-on-click="closeOnClick" left bottom offset-y>
    <template v-slot:activator="menu">

      <v-btn :color="corBotao" text v-on="{ ...menu.on }" v-if="textoBotao">
        <span>{{ textoBotao }}</span>
      </v-btn>

      <v-tooltip left v-else>
        <template v-slot:activator="tooltip">
          <v-btn :color="corBotao" icon v-on="{ ...menu.on, ...tooltip.on }">
            <v-icon>{{ iconeBotao }}</v-icon>
          </v-btn>
        </template>
        <span>{{ titulo }}</span>
      </v-tooltip>

    </template>

    <v-card :width="largura">
      <v-card-title v-show="titulo">{{ titulo }}</v-card-title>

      <v-card-text>
        <slot>{{ texto }}</slot>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed ref="btnNao" @click="responder(false)" :disable="props.loading">{{ botaoNao }}</v-btn>
        <v-btn depressed dark ref="btnSim" :color="corBotaoSim" :loading="props.loading" @click="responder(true)">{{ botaoSim }}</v-btn >
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script setup>

  import { ref, watch } from 'vue';

  const props = defineProps({
    titulo: {
      type: String,
      default: null,
    },
    texto: {
      type: String,
      default: null,
    },
    iconeBotao: {
      type: String,
      default: "mdi-delete",
    },
    textoBotao: {
      type: String,
      default: null,
    },
    corBotao: {
      type: String,
      default: null,
    },
    largura: {
      type: String,
      default: "400px",
    },
    dividers: {
      type: Boolean,
      default: false,
    },
    botaoSim: {
      type: String,
      default: "Sim",
    },
    botaoNao: {
      type: String,
      default: "Não",
    },
    corBotaoSim: {
      type: String,
      default: "primary",
    },

    loading: {
      type: Boolean,
      default: false,
    },
  })

  let menu = ref(false);
  let closeOnClick = ref(true);
  
  const emit = defineEmits(['click:sim', 'click:nao'])

  const responder = (resposta) => {
    if (resposta == false) {
      menu.value = false;
      emit('click:nao')
    } else {
      menu.value = false;
      closeOnClick.value = false;
      emit('click:sim')
    }
  }

  watch(() => props.loading, (newValue, oldValue) => {
    if (oldValue == true && newValue == false) {
      menu.value = false;
      closeOnClick.value = true;
    }
  })
</script>

<style lang="scss" scoped>

</style>